// Exports
export default {
	"header": "header_Ropvq",
	"titleAndDateTimeWrapper": "titleAndDateTimeWrapper_GZAov",
	"oneColLayout": "oneColLayout_CxlHI",
	"mobileOneColLayout": "mobileOneColLayout_katg7",
	"titleAndDateTime": "titleAndDateTime_r30Yo",
	"title": "title_5DMeQ",
	"datetime": "datetime_8qTfr",
	"confNumber": "confNumber_2uh8D",
	"closeButton": "closeButton_K08LE",
	"backButton": "backButton_gHJr9"
};
